import React from "react";
import { Tabs } from 'antd';
import LabTaskList from "../components/lab-latex/LabTaskList";
import LabRecievingLatexList from "../components/lab-latex/LabRecievingLatexList";
import LabTruckHistoryView from "../components/lab-latex/LabTruckHistoryView";
import LabPondList from "../components/lab-latex/LabPondList";
import LabStorageTankList from "../components/lab-latex/LabStorageTankList";
import LabSkimList from "../components/lab-latex/LabSkimList";
import TruckHistoryView from "../views/TruckHistoryView";

export default function LabLatexQCView() {

  const items = [
    {
      key: 'ถาดงาน',
      label: 'การ์ดงานเข้า',
      children: <LabTaskList concentrate={true} />,
    },
    {
      key: 'truck',
      label: 'รถเข้าทั้งหมด',
      children: <TruckHistoryView/>,
    },
    {
      key: 'latex',
      label: 'น้ำยางสด',
      children: <LabTruckHistoryView/>,
    },
    {
      key: 'pond',
      label: 'บ่อน้ำยางสด',
      children: <LabPondList/>,
    },
    {
      key: 'skim',
      label: 'สกิม',
      children: <LabSkimList/>,
    },
  ];

  return(
    <div style={{ marginTop : 20}}>
      <Tabs
        destroyInactiveTabPane
        defaultActiveKey="task" 
        items={items} 
      />

    </div>
  )
}